import moment from "moment";

export const DEFAULT_TOKEN = "123";
export const MenuWidth = 109;
export const DefaultPaginationCount = 10;

export const CANDIDATE_PORTAL_URL_SIMULATION = "dashboard/score";
export const IS_SIMULATION_MODE = "isSimulationMode";
export const CANDIDATE_PORTAL_URL = process.env.REACT_APP_CANDIDATE_APP_URL || "";

export const API = {
    LOGIN: "expertAdminLogin",
    /** tools api */
    SENDEMAILSAPI: "sendEmail",
    GET_USER_STATISTICS_API: "getResultForUserActivitySearch",
    GET_CANDIDATE_ACTIVITY: "getCandidateActivity",

    /** questions api */
    GETQUESTION: "getResultforQuestionSearch",
    GETQUESTIONDETAIL: "getQuestionsDetails",
    UPDATEQUESTIONDETAIL: "updateQuestionDetails",
    ADDQUESTIONDETAIL: "addQuestionDetails",
    ADDHINT: "createHint",
    UPDATEHINT: "updateHint",
    GETHINTS: "getAllHints",
    SETQUESTIONCOMPLETE: "setQuestionComplete",
    ADDSAMPLESOLUTION: "createSampleSolution",
    UPDATESAMPLESOLUTION: "updateSampleSolution",
    /**capabilities api */
    GETALLCAPABILITIES: "getResultforCapabilitySearch",
    GETCAPABILITYDETAIL: "getCapabilityDetails",
    UPDATECAPABILITYDETAIL: "updateCapability",
    ADDCAPABILITYDETAIL: "createCapability",
    GETALLCATEGORIES: "getCategoryList",
    GETCATEGORIESANDSUBCATEGORIES: "getCategoryAndSubCategoryList",
    GETCANDIDATESASSOCIATEDEXPERT: "getCandidatesAssociatedByExpert",
    SETCAPABILITYCOMPLETE: "setCapabilityComplete",
    CREATECATEGORY: "createCategory",
    UPDATECATEGORY: "updateCategory",
    CREATESUBCATEGORY: "createSubCategory",
    UPDATESUBCATEGORY: "updateSubCategory",
    DELETECATEGORY: "deleteCategory",
    DELETESUBCATEGORY: "deleteSubcategory",
    GETCATEGORYDETAILS: "getCategoryDetails",
    GETSUBCATEGORYDETAILS: "getSubcategoryDetails",
    GETCATEGORYTREE: "getCategoryTree",
    ADDQUESTIONEVALUATION: "addEvaluationToCapability",
    ADDQUESTIONTOCAPABILITY: "addQuestionToCapability",
    REMOVEQUESTIONTOCAPABILITY: "removeQuestionToCapability",
    SETENTITYSTATE: "setEntityState",
    /** tracks api */
    GETALLTRACKS: "getResultForTrackSearch",
    UPDATETRACK: "updateTrack",
    GETTRACKDETAILS: "getTrackDetails",
    CREATETRACK: "createTrack",
    GETENUMS: "getEnums",
    GETEXPERTS: "getExperts",
    GETMARKETS: "getMarkets",
    GETMARKETSFORLOGIN: "getMarketsForLogin",
    SETTRACKCOMPLETE: "setTrackComplete",
    GETTRACKTREE: "getTrackTree",
    CREATETRACKTREE: "createTrackTree",
    VALIDATETRACK: "validateTrack",
    GETTRACKSUMMARY: "getTrackSummary",
    UPDATETRACKHIERARCHY: "updateTrackHierarchy",
    GETQUESTIONSFROMCAPABILITY: "getQuestionsFromCapability",
    ADDQUESTIONSTOCAPABILITY: "addQuestionsToCapability",
    GETSUBCATEGORYLISTBYCATEGORYID: "getSubcategoryListByCategoryId",
    GETCONFIG: "getConfig",
    /** track landing page api */
    GETALLTRACKSFORLANDING: "getResultsForTrackLandingPageSearch",
    GETTRACKSFORCOMBOBOX: "getTracksForComboBox",
    CREATETRACKLANDINGPAGEDETAIL: "createTrackLandingPageDetail",
    UPDATETRACKLANDINGPAGEDETAIL: "updateTrackLandingPageDetail",
    GETTRACKLANDINGPAGEDETAILS: "getTrackLandingPageDetails",
    REFRESHDATAFROMTRACKANDPRODUCT: "refreshDataFromTrackAndProduct",
    GETALLTRACKSADDPRODUCT: "getTracks",
    GETALLEXPERTS: "getExperts/admin",
    UPDATELANDINPAGEPRICE: "updateLandingPageProductPrice",
    // Experts Api
    GetResultsForExpertSearch: "getResultsForExpertSearch",
    GETEXPERTDETAIL: "getExpertDetails",
    UPDATEEXPERTDETAIL: "updateExpert",
    ADDEXPERT: "createExpert",
    UPDATECANDIDATEPLAN: "updateCandidatePlan",
    // MARKETS
    GETALLMARKETS: "getMarkets",

    // EvaluationPlatformTalkToExpert
    GETMEETINGS: "getMeetings",

    // PAYMENT AND PRODUCT APIS
    PPP_PRODUCT: "getProducts",
    GET_ENUMS: "metadata/getEnums",
    PPP_CREATEPRODUCT: "createProduct",
    PPP_GETPRODUCTBYID: "getProductsById",
    PPP_UPDATEPRODUCT: "updateProduct",
    PPP_UPDATEPRICE: "changeStripePrice",
    PPP_GETPRODUCTSFORTRACKANDEXPERT: "getProductsForTrackAndExpert",
    PPP_CREATECLASSINFO: "createClassInfo",
    PPP_GETCLASSINFO: "getClassInfo",
    PPP_GETRESULTFORCLASSSEARCH: "getResultForClassSearch",
    PPP_UPDATECLASSINFO: "updateClassInfo",

    // GET CANDIDATE AUTHROIZATION TOKEN
    GETCANDIDATEAUTHTOKEN: "getCandidateAuthorizationToken",
};

export const Entity = {
    CATEGORY: "CATEGORY",
    SUBCATEGORY: "SUBCATEGORY",
    CAPABILITY: "CAPABILITY",
    QUESTION: "QUESTION",
    TRACK: "TRACK",
};

export const TemplateTypes = {
    DEFAULT: "DEFAULT_TEMPLATE",
    MARKETING: "MARKET_TEMPLATE",
    CUSTOMIZED: "CUSTOMIZED",
};

export const View = {
    TRACKSUMMARY: "TrackSummary",
    CATEGORY: "CATEGORY",
    VIEWCATEGORY: "VIEWCATEGORY",
    SUBCATEGORY: "SUBCATEGORY",
    VIEWSUBCATEGORY: "VIEWSUBCATEGORY",
    CAPABILITY: "CAPABILITY",
    VIEWCAPABILITY: "VIEWCAPABILITY",
    QUESTION: "QUESTION",
    VIEWQUESTION: "VIEWQUESTION",
    TRACK: "TRACK",
    EDITCATEGORY: "EDITCATEGORY",
    EDITSUBCATEGORY: "EDITSUBCATEGORY",
    EDITCAPABILITY: "EDITCAPABILITY",
    EDITQUESTION: "EDITQUESTION",
};

export const Enum = {
    TrackSubType: "TrackSubType",
    TrackType: "TrackType",
};

export const ColorCode = {
    Default: "#5b94e3",
    [Entity.CATEGORY]: "#978217",
    [Entity.CAPABILITY]: "rgba(123, 97, 255, 1)",
    [Entity.SUBCATEGORY]: "#A5636D",
    [Entity.QUESTION]: "rgba(0, 0, 0, 0.6)",
};

export const MenuItems = {
    tracks: "TRACKS",
    questions: "QUESTIONS",
    capabilities: "CAPABILITIES",
    yourCandidates: "YOURCANDIDATES",
    trackSettings: "TRACKSETTINGS",
    experts: "EXPERTS",
    products: "PRODUCTS",
    mailTool: "MAILTOOL"
};

export enum ToolsDashBoardPath {
    CREATE_EMAIL = "create-mail",
    EMAIL_STATUS = "mail-status",
    USER_STATISTICS = "user-statistics"
}

export const Routes = {
    [MenuItems.tracks]: "/tracks",
    [MenuItems.questions]: "/questions",
    [MenuItems.capabilities]: "/capabilities",
    [MenuItems.yourCandidates]: "/your-candidates",
    [MenuItems.trackSettings]: "/trackSettings",
    [MenuItems.experts]: "/experts",
    [MenuItems.products]: "/products",
    [MenuItems.mailTool]: `/tools/${ToolsDashBoardPath.CREATE_EMAIL}`,
};

export const LastModifiedOptions = {
    Last_Seven_Days: "Last 7 Days",
    Last_Fifteen_Days: "Last 15 Days",
    Last_Thirty_Days: "Last 30 Days",
    Last_Sixty_Days: "Last 60 Days",
};

export const AnswerTypeEnum = [
    "RICH_TEXT",
    "CODE",
    "DRAWING",
    "AUDIO",
    "VIDEO",
    "CONTENT_RESPONSE"
];

export const QuestionTypeEnum = ["TRAINING", "EVALUATION", "FREESAMPLE", "CONTENT"];

export const AnswerType = {
    [AnswerTypeEnum[0]]: "Rich Text",
    [AnswerTypeEnum[1]]: "Code",
    [AnswerTypeEnum[2]]: "Drawing",
    [AnswerTypeEnum[3]]: "Audio",
    [AnswerTypeEnum[4]]: "Video",
    [AnswerTypeEnum[5]]: "Content Response",
};

export const QuestionType: any = {
    [QuestionTypeEnum[0]]: "Training",
    [QuestionTypeEnum[1]]: "Evaluation",
    [QuestionTypeEnum[2]]: "Free Sample",
    [QuestionTypeEnum[3]]: "Content",
};

export const State = {
    INPROGRESS: "In Progress",
    COMPLETED: "Completed",
    DISABLED: "Disabled",
    PUBLISHED: "Published",
};

export const Difficulty = {
    EASY: "Easy",
    MEDIUM: "Medium",
    HARD: "Hard",
};

export const LastModifiedDates = [
    {
        id: moment.utc().subtract(7, "d").format("MM/DD/YYYY"),
        name: LastModifiedOptions.Last_Seven_Days,
    },
    {
        id: moment.utc().subtract(15, "d").format("MM/DD/YYYY"),
        name: LastModifiedOptions.Last_Fifteen_Days,
    },
    {
        id: moment.utc().subtract(30, "d").format("MM/DD/YYYY"),
        name: LastModifiedOptions.Last_Thirty_Days,
    },
    {
        id: moment.utc().subtract(60, "d").format("MM/DD/YYYY"),
        name: LastModifiedOptions.Last_Sixty_Days,
    },
];

export const StatisticsType = {
    USER_COUNT: 'USER_COUNT',
    TRACK: 'TRACK'
}

export const UserStatisticsType = [
    { id: StatisticsType.USER_COUNT, name: 'User Count' },
    { id: StatisticsType.TRACK, name: 'Track' },
]

export const CandidatesType = {
    ACTIVE_CANDIDATES: "ACTIVE_CANDIDATES",
    INACTIVE_CANDIDATES: "INACTIVE_CANDIDATES"
}

export const UserStatisticsUser = [
    { id: CandidatesType.ACTIVE_CANDIDATES, name: 'Active Candidates' },
    { id: CandidatesType.INACTIVE_CANDIDATES, name: 'Inactive Candidates' },
]

export const productCategories = [
    {
        type: "None",
        value: 0,
    },
    {
        type: "SubscriptionProduct",
        value: 1,
    },

    {
        type: "ContractProduct",
        value: 2,
    },
    {
        type: "Free",
        value: 3,
    },
    {
        type: "EvaluationProduct",
        value: 4,
    },
];

export const filterProductCategories = [
    {
        type: "None",
        value: "None",
    },
    {
        type: "isSubscriptionProduct",
        value: "isSubscriptionProduct",
    },

    {
        type: "isContractProduct",
        value: "isContractProduct",
    },
    {
        type: "isFree",
        value: "isFree",
    },
    {
        type: "isEvaluationProduct",
        value: "isEvaluationProduct",
    },
];
export const productOrder = [
    {
        type: "one",
        value: "one",
    },
    {
        type: "two",
        value: "two",
    },
    {
        type: "three",
        value: "three",
    },
    {
        type: "four",
        value: "four",
    },
    {
        type: "none",
        value: "none",
    },
];

export const productTypes = [
    {
        label: "Expert",
        value: "expert",
    },
    {
        label: "TrackPlan",
        value: "trackPlan",
    },
    {
        label: "Class",
        value: "ihclass",
    },
];

export const SubProductType = {
    EXPERTQUESTION: "expertQuestion",
    EXPERTMEETING: "expertMeeting",
    TRACKPLANPLACEMENT: "trackPlanPlacement",
    TRACKPLANFREE: "trackPlanFree",
    TRACKPLANSUBSCRIPTION: "trackPlanSubscription",
    TRACKPLANCONTRACT: "trackPlanContract",
    TRACKPLANEVALUATION: "trackPlanEvaluation",
    MONTHLYSUBSCRIPTION: "monthlySubscription",
};

export const ProductType = {
    EXPERT: "expert",
    TRACKPLAN: "trackPlan",
    IHCLASS: "ihclass",
};

export const EnrollType = {
    FOR_PLACEMENT: "FOR_PLACEMENT",
    CAN_ENROLL: "CAN_ENROLL",
    MUST_BUY: "MUST_BUY",
};

export const subProductTypes = [
    {
        label: "Expert Question",
        value: SubProductType.EXPERTQUESTION,
        parent: [ProductType.EXPERT],
    },
    {
        label: "Expert Meeting",
        value: SubProductType.EXPERTMEETING,
        parent: [ProductType.EXPERT],
    },
    {
        label: "Track Plan Placement",
        value: SubProductType.TRACKPLANPLACEMENT,
        parent: [ProductType.TRACKPLAN],
    },
    {
        label: "Track Plan Free",
        value: SubProductType.TRACKPLANFREE,
        parent: [ProductType.TRACKPLAN],
    },
    {
        label: "Track Plan Subscription",
        value: SubProductType.TRACKPLANSUBSCRIPTION,
        parent: [ProductType.TRACKPLAN],
    },
    {
        label: "Track Plan Contract",
        value: SubProductType.TRACKPLANCONTRACT,
        parent: [ProductType.TRACKPLAN],
    },
    {
        label: "Track Plan Evaluation",
        value: SubProductType.TRACKPLANEVALUATION,
        parent: [ProductType.TRACKPLAN],
    },
    {
        label: "Monthly Subscription",
        value: SubProductType.MONTHLYSUBSCRIPTION,
        parent: [ProductType.IHCLASS],
    },
];

export const productBooleanCheck = [
    {
        type: "Yes",
        value: true,
    },
    {
        type: "No",
        value: false,
    },
];

export const TimePeriod = {
    PAST: "PAST",
    CURRENT: "CURRENT",
    FUTURE: "FUTURE",
    ALL: "ALL",
};

export const recurringPriceType = [
    {
        label: "Day",
        value: "day",
    },
    {
        label: "Week",
        value: "week",
    },
    {
        label: "Month",
        value: "month",
    },
    {
        label: "Year",
        value: "year",
    },
];

export const Market = {
    INTERVIEWHELP: "INTERVIEW_HELP",
};

export const PageType = {
    ADDQUESTION: "Add Question",
    EDITQUESTION: "Edit Question",
};

export const TrackType = {
    TPM: "Technical Project Manager",
    SDM: "SDM",
    SDE: "SDE",
    TEST: "TEST",
    TEST_TPM: "TEST_TPM",
    TEST_SDM: "TEST_SDM",
    TEST_SDE: "TEST_SDE",
    TEST_TRACK1: "TEST_TRACK1",
    TEST_TRACK2: "TEST_TRACK2",
    TEST_TRACK3: "TEST_TRACK",
};

export const CONFIGTYPES = {
    TRACKTAGS: "TRACKTAGS",
    PRODUCTTAGS: "PRODUCTTAGS"
};

export const EventProps = {
    QUESTIONADDEDFROMCAPABILITY: "Question Added from capability",
    QUESTIONADDED: "Question Added",
    QUESTIONUPDATED: "Question Updated",
    QUESTIONREMOVED: "Question Added",
    CAPABILITYUPDATED: "Capability Updated",
};

export const StorageClient = {
    ENDPOINT: "s3.amazonaws.com",
    TRACKLOGODIRECTORY: "tracks/logo",
    EXPERTSLOGODIRECTORY: "experts",
    getUniqueExpertDirectory: (expertId: string) => `experts/${expertId}/images`,
    OTHERIMAGES: "otherimages",
};

export const trackEnrollTypes: any = {
    MUST_BUY: "Paid",
    CAN_ENROLL: "Free",
};

export const RoleType = {
    EXPERT: 'EXPERT',
    MARKETING: 'MARKETING',
    EXPERT_ADMIN: 'EXPERT_ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
    HIRING_MANAGER: 'HIRING_MANAGER',
    COMPANY: 'COMPANY',
    RECRUITER: 'RECRUITER'
}

export const RoleTypeOptions = [
    { label: "NOT AVAILABLE", value: "NOT_AVAILABLE" },
    { label: "EXPERT", value: RoleType.EXPERT },
    { label: "EXPERT ADMIN", value: RoleType.EXPERT_ADMIN },
    { label: "SUPER ADMIN", value: RoleType.SUPER_ADMIN },
    { label: "MARKETING", value: RoleType.MARKETING },
    { label: "COMPANY", value: RoleType.COMPANY },
    { label: "HIRING MANAGER", value: RoleType.HIRING_MANAGER },
    { label: "RECRUITER", value: RoleType.RECRUITER },
];

export const AccessLevels = {
    ALL: "ALL",
    ADMIN_ALL: "ADMIN_ALL",
    ADMIN_INSERT: "ADMIN_INSERT",
    ADMIN_DELETE: "ADMIN_DELETE",
    ADMIN_SEARCH: "ADMIN_SEARCH",
    EXPERT_ALL: "EXPERT_ALL",
    EXPERT_VIEW: "EXPERT_VIEW",
    EXPERT_EDIT_CANDIDATE_RESPONSE: "EXPERT_EDIT_CANDIDATE_RESPONSE",
    EXPERT_GIVE_FEEDBACK: "EXPERT_GIVE_FEEDBACK",
    EXPERT_SEE_CANDIDATE_DASHBOARD: "EXPERT_SEE_CANDIDATE_DASHBOARD",
    EXPERT_SEE_OTHER_EXPERT_FEEDBACK: "EXPERT_SEE_OTHER_EXPERT_FEEDBACK",
};

export const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const TrackVideoTypes = {
    SELLING: "SELLING",
};
export const TrackVideoTypesArr = [
    {
        label: "Selling",
        value: TrackVideoTypes.SELLING,
    },
];

export const API_STATUSES = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
}
export enum ToolsDashBoard {
    CREATE_EMAIL,
    EMAIL_STATUS
}

export const timeZones = ["Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Asmera", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Bissau", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Timbuktu", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/ComodRivadavia", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Atka", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Buenos_Aires", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Catamarca", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Coral_Harbour", "America/Cordoba", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Ensenada", "America/Fort_Nelson", "America/Fort_Wayne", "America/Fortaleza", "America/Glace_Bay", "America/Godthab", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Indianapolis", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Jujuy", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Knox_IN", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Louisville", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Mendoza", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montreal", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Nuuk", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Acre", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Rosario", "America/Santa_Isabel", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Shiprock", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Virgin", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/South_Pole", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Ashkhabad", "Asia/Atyrau", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Calcutta", "Asia/Chita", "Asia/Choibalsan", "Asia/Chongqing", "Asia/Chungking", "Asia/Colombo", "Asia/Dacca", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Harbin", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Istanbul", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kashgar", "Asia/Kathmandu", "Asia/Katmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macao", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Rangoon", "Asia/Riyadh", "Asia/Saigon", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Tel_Aviv", "Asia/Thimbu", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ujung_Pandang", "Asia/Ulaanbaatar", "Asia/Ulan_Bator", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faeroe", "Atlantic/Faroe", "Atlantic/Jan_Mayen", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/ACT", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Canberra", "Australia/Currie", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/LHI", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/NSW", "Australia/North", "Australia/Perth", "Australia/Queensland", "Australia/South", "Australia/Sydney", "Australia/Tasmania", "Australia/Victoria", "Australia/West", "Australia/Yancowinna", "Brazil/Acre", "Brazil/DeNoronha", "Brazil/East", "Brazil/West", "CET", "CST6CDT", "Canada/Atlantic", "Canada/Central", "Canada/Eastern", "Canada/Mountain", "Canada/Newfoundland", "Canada/Pacific", "Canada/Saskatchewan", "Canada/Yukon", "Chile/Continental", "Chile/EasterIsland", "Cuba", "EET", "EST", "EST5EDT", "Egypt", "Eire", "Etc/GMT", "Etc/GMT+0", "Etc/GMT+1", "Etc/GMT+10", "Etc/GMT+11", "Etc/GMT+12", "Etc/GMT+2", "Etc/GMT+3", "Etc/GMT+4", "Etc/GMT+5", "Etc/GMT+6", "Etc/GMT+7", "Etc/GMT+8", "Etc/GMT+9", "Etc/GMT-0", "Etc/GMT-1", "Etc/GMT-10", "Etc/GMT-11", "Etc/GMT-12", "Etc/GMT-13", "Etc/GMT-14", "Etc/GMT-2", "Etc/GMT-3", "Etc/GMT-4", "Etc/GMT-5", "Etc/GMT-6", "Etc/GMT-7", "Etc/GMT-8", "Etc/GMT-9", "Etc/GMT0", "Etc/Greenwich", "Etc/UCT", "Etc/UTC", "Etc/Universal", "Etc/Zulu", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belfast", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Kirov", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Nicosia", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Saratov", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Tiraspol", "Europe/Ulyanovsk", "Europe/Uzhgorod", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zaporozhye", "Europe/Zurich", "GB", "GB-Eire", "GMT", "GMT+0", "GMT-0", "GMT0", "Greenwich", "HST", "Hongkong", "Iceland", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Iran", "Israel", "Jamaica", "Japan", "Kwajalein", "Libya", "MET", "MST", "MST7MDT", "Mexico/BajaNorte", "Mexico/BajaSur", "Mexico/General", "NZ", "NZ-CHAT", "Navajo", "PRC", "PST8PDT", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Ponape", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Samoa", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Truk", "Pacific/Wake", "Pacific/Wallis", "Pacific/Yap", "Poland", "Portugal", "ROC", "ROK", "Singapore", "Turkey", "UCT", "US/Alaska", "US/Aleutian", "US/Arizona", "US/Central", "US/East-Indiana", "US/Eastern", "US/Hawaii", "US/Indiana-Starke", "US/Michigan", "US/Mountain", "US/Pacific", "US/Samoa", "UTC", "Universal", "W-SU", "WET", "Zulu"]